<table
  mat-table
  [dataSource]="result"
  multiTemplateDataRows
  class="mat-elevation-z8"
>
  <ng-container matColumnDef="typeAction">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo De Boleta</th>
    <td mat-cell *matCellDef="let element">
      {{ element.typeAction }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioDocument">
    <th mat-header-cell class="header" *matHeaderCellDef>CNPJ</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioDocument }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioName">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome do Fundo</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBank">
    <th mat-header-cell class="header" *matHeaderCellDef>Banco</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBank }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioBranch">
    <th mat-header-cell class="header" *matHeaderCellDef>Agência</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioBranch }}
    </td>
  </ng-container>

  <ng-container matColumnDef="portfolioAccount">
    <th mat-header-cell class="header" *matHeaderCellDef>Conta Corrente</th>
    <td mat-cell *matCellDef="let element">
      {{ element.portfolioAccount }}
    </td>
  </ng-container>

  <ng-container matColumnDef="broker">
    <th mat-header-cell class="header" *matHeaderCellDef>Nome Corretora</th>
    <td mat-cell *matCellDef="let element">
      {{ element.broker }}
    </td>
  </ng-container>

  <ng-container matColumnDef="clearingAgent">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Agente de Compensação
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.clearingAgent }}
    </td>
  </ng-container>

  <ng-container matColumnDef="loanType">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Natureza da operação
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.loanType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="isReversibleByDonor">
    <th mat-header-cell class="header" *matHeaderCellDef>
      É Reversível Pelo Doador?
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.isReversibleByDonor ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="dueDate">
    <th mat-header-cell class="header" *matHeaderCellDef>Data de Vencimento</th>
    <td mat-cell *matCellDef="let element">
      {{ element.dueDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="contractNumber">
    <th mat-header-cell class="header" *matHeaderCellDef>Número do Contrato</th>
    <td mat-cell *matCellDef="let element">
      {{ element.contractNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="paperCode">
    <th mat-header-cell class="header" *matHeaderCellDef>Código Papel</th>
    <td mat-cell *matCellDef="let element">
      {{ element.paperCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="stocksAmount">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Quantidade de Ações
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.stocksAmount | number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="finalGraceDate">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Data Final de Carência
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.finalGraceDate | date: "dd/MM/yyyy" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="remunerationRate">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Taxa de Remuneração
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.remunerationRate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="commissionFee">
    <th mat-header-cell class="header" *matHeaderCellDef>Taxa de comissão</th>
    <td mat-cell *matCellDef="let element">
      {{ element.commissionFee }}
    </td>
  </ng-container>

  <ng-container matColumnDef="settlementPeriodicity">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Período de Liquidação
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.settlementPeriodicity }}
    </td>
  </ng-container>

  <ng-container matColumnDef="operationCode">
    <th mat-header-cell class="header" *matHeaderCellDef>Tipo de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.operationCode }}
    </td>
  </ng-container>

  <ng-container matColumnDef="loanOperationTypeId">
    <th mat-header-cell class="header" *matHeaderCellDef>Código de Operação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.loanOperationTypeId }}
    </td>
  </ng-container>

  <ng-container matColumnDef="marginCredit">
    <th mat-header-cell class="header" *matHeaderCellDef>Crédito de Margem</th>
    <td mat-cell *matCellDef="let element">
      {{ element.marginCredit ? "SIM" : "NÃO" }}
    </td>
  </ng-container>

  <ng-container matColumnDef="priceSettlementReference">
    <th mat-header-cell class="header" *matHeaderCellDef>
      Cotação Liquidação Preço Referência
    </th>
    <td mat-cell *matCellDef="let element">
      {{ element.priceSettlementReference }}
    </td>
  </ng-container>

  <ng-container matColumnDef="annotations">
    <th mat-header-cell class="header" *matHeaderCellDef>Observação</th>
    <td mat-cell *matCellDef="let element">
      {{ element.annotations }}
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="ColumnsLoan.length">
      <div
        class="example-element-detail"
        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="example-element-description">
          <div class="title-description">
            <h5>Erros encontrados:</h5>
          </div>
          <ul *ngFor="let error of element.errors">
            <li>
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="ColumnsLoan"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: ColumnsLoan"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: ['expandedDetail']"
    class="example-detail-row"
  ></tr>
</table>
